// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.12103"][{"9802":0}[chunkId]] || "1.12104") + "/" + chunkId + ".js";
};